import { isFieldRequired } from '../config/tabs.js';

export const isNonEmpty = (v) => String(v ?? '').trim().length > 0;

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v ?? '').trim());

/**
 * For UA the input is the local 9-digit form (no trunk-0, no +380) — strict.
 * For other countries: lax 9+ digit check until we add per-country rules.
 */
export const isPhone = (v, country) => {
  const digits = String(v ?? '').replace(/\D/g, '');
  if (country && String(country).toUpperCase() === 'UA') return digits.length === 9;
  return digits.length >= 9;
};

/**
 * Validate a tab's field set against the contact state object.
 *
 * `deliveryMethodId` is passed so we can honour `requiredForCarriers` on
 * fields like "По батькові" (mandatory only for Укрпошта).
 *
 * @param {Array<{name:string,required?:boolean,requiredForCarriers?:string[],type:string}>} fields
 * @param {Record<string,string>} values
 * @param {string} [deliveryMethodId]
 * @returns {Record<string,string>} field name -> error message
 */
export function validateFields(fields, values, deliveryMethodId) {
  const errors = {};
  for (const f of fields) {
    const v = values?.[f.name];
    const required = isFieldRequired(f, deliveryMethodId);
    if (required && !isNonEmpty(v)) {
      errors[f.name] = "Обов'язкове поле";
      continue;
    }
    if (!isNonEmpty(v)) continue;
    if (f.type === 'email' && !isEmail(v)) errors[f.name] = 'Невірна електронна пошта';
    if (f.type === 'phone') {
      const country = values?.[`${f.name}Country`];
      if (!isPhone(v, country)) {
        errors[f.name] = String(country || '').toUpperCase() === 'UA'
          ? 'Введіть 9 цифр після +380'
          : 'Невірний номер телефону';
      }
    }
  }
  return errors;
}
